var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 40,
    viewBox: "0 0 142 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.673 29.2136L117.799 12.3596H120.824L124.521 26.5169L128.386 12.3596H131.412L135.277 26.5169L138.974 12.3596H141.999L137.126 29.2136H133.596L129.899 15.8315L126.202 29.2136H122.673Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.241 29.7192C103.695 29.7192 101.006 25.6742 101.006 20.7866C101.006 15.8989 103.695 11.854 109.241 11.854C114.787 11.854 117.476 15.8989 117.476 20.7866C117.476 25.6742 114.787 29.7192 109.241 29.7192ZM104.031 20.7866C104.031 25.6742 106.384 27.6967 109.241 27.6967C112.098 27.6967 114.451 25.6742 114.451 20.7866C114.451 15.8989 112.098 13.8765 109.241 13.8765C106.384 13.8765 104.031 15.8989 104.031 20.7866Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.98 29.2136H96.123V7.30347H98.98V29.2136Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7613 29.2136H90.9043V7.30347H93.7613V29.2136Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3403 29.7192C75.7944 29.7192 73.1055 25.6742 73.1055 20.7866C73.1055 15.8989 75.7944 11.854 81.1723 11.854C86.7182 11.854 88.9029 16.0675 88.9029 20.1124V21.4607H76.1305C76.3322 25.8765 78.6178 27.6967 81.3403 27.6967C83.5251 27.6967 85.3737 26.5169 85.8779 24.1574H88.7349C88.0626 27.3596 85.5418 29.7192 81.3403 29.7192ZM81.1723 13.8765C78.5842 13.8765 76.5675 15.5282 76.1977 19.4383H85.8779C85.8779 15.5619 83.7267 13.8765 81.1723 13.8765Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2324 29.2136V7.30347H52.6019L59.6604 25.8428L66.7188 7.30347H71.0883V29.2136H68.2313V10.3372L61.0048 29.2136H58.3159L51.0894 10.3372V29.2136H48.2324Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9429 37.7528C29.7195 37.7528 37.645 29.8046 37.645 20C37.645 10.1954 29.7195 2.24719 19.9429 2.24719C10.1663 2.24719 2.24078 10.1954 2.24078 20C2.24078 29.8046 10.1663 37.7528 19.9429 37.7528ZM19.9429 40C30.9571 40 39.8858 31.0457 39.8858 20C39.8858 8.9543 30.9571 0 19.9429 0C8.92874 0 0 8.9543 0 20C0 31.0457 8.92874 40 19.9429 40Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4084 31.6854C28.8437 31.6854 34.0605 26.4536 34.0605 20C34.0605 13.5463 28.8437 8.31457 22.4084 8.31457C15.9732 8.31457 10.7564 13.5463 10.7564 20C10.7564 26.4536 15.9732 31.6854 22.4084 31.6854ZM22.4084 33.9326C30.0812 33.9326 36.3012 27.6947 36.3012 20C36.3012 12.3052 30.0812 6.06738 22.4084 6.06738C14.7356 6.06738 8.51562 12.3052 8.51562 20C8.51562 27.6947 14.7356 33.9326 22.4084 33.9326Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2701 24.9439C21.9927 24.9439 24.1998 22.7305 24.1998 20.0001C24.1998 17.2697 21.9927 15.0563 19.2701 15.0563C16.5475 15.0563 14.3404 17.2697 14.3404 20.0001C14.3404 22.7305 16.5475 24.9439 19.2701 24.9439ZM19.2701 27.1911C23.2302 27.1911 26.4406 23.9716 26.4406 20.0001C26.4406 16.0286 23.2302 12.8091 19.2701 12.8091C15.3099 12.8091 12.0996 16.0286 12.0996 20.0001C12.0996 23.9716 15.3099 27.1911 19.2701 27.1911Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.405fffdee7e569a066f4f5d12c5eed21.svg";